import { Storage as f } from "@fond-of/storage";
import { isSSR as g } from "@fond-of/env";
function i(e) {
  this.message = e;
}
i.prototype = new Error(), i.prototype.name = "InvalidCharacterError";
var u = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new i("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var n, o, s = 0, a = 0, E = ""; o = t.charAt(a++); ~o && (n = s % 4 ? 64 * n + o : o, s++ % 4) ? E += String.fromCharCode(255 & n >> (-2 * s & 6)) : 0) o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
  return E;
};
function h(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(n) {
      return decodeURIComponent(u(n).replace(/(.)/g, function(o, s) {
        var a = s.charCodeAt(0).toString(16).toUpperCase();
        return a.length < 2 && (a = "0" + a), "%" + a;
      }));
    }(t);
  } catch {
    return u(t);
  }
}
function c(e) {
  this.message = e;
}
function m(e, t) {
  if (typeof e != "string") throw new c("Invalid token specified");
  var n = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(h(e.split(".")[n]));
  } catch (o) {
    throw new c("Invalid token specified: " + o.message);
  }
}
c.prototype = new Error(), c.prototype.name = "InvalidTokenError";
const w = (e) => {
  if (g())
    return null;
  const t = new URLSearchParams(window.location.search);
  return t.has(e) ? t.get(e) : null;
}, p = (e) => {
  if (g())
    return;
  const t = new URLSearchParams(window.location.search);
  t.delete(e);
  const n = t.toString() ? `?${t.toString()}` : "", o = window.location.pathname + n + window.location.hash;
  window.history.replaceState(null, "", o);
}, l = "TOKEN_STORAGE_KEY", d = "signature", S = "uuid", C = "cart", _ = "checkoutAddress", T = "checkoutSuccess", O = "checkoutPayment", A = "triggerBeginCheckout", I = "loginConfirmed", N = "guestLoginConfirmed", U = "blocked", v = "hideWelcomeBack", M = "selectedPaymentMethod", r = f.create("localStorage"), k = () => {
  if (!r)
    throw new Error("Storage adapter not found");
  const e = w(d);
  return e ? (p(d), r.set(l, e)) : !1;
}, y = () => {
  if (!r)
    throw new Error("Storage adapter not found");
  r.delete(l), r.delete(S), r.delete(C), r.delete(T), r.delete(_), r.delete(O), r.delete(M), sessionStorage.removeItem(A), sessionStorage.removeItem(I), sessionStorage.removeItem(N), sessionStorage.removeItem(U), sessionStorage.removeItem(v);
}, b = () => {
  if (!r)
    throw new Error("Storage adapter not found");
  return r.get(l) || w(d);
}, D = (e) => {
  if (!e)
    return !0;
  const { exp: t } = m(e);
  return new Date(t * 1e3) < /* @__PURE__ */ new Date();
};
export {
  b as getToken,
  D as isTokenExpired,
  k as login,
  y as logout
};
//# sourceMappingURL=token-manager.js.map
